const trueColourMap = {
	white: '#ffffff',
	cloud: '#f0f0f1',
	icy: '#f0f0f1',
	snow: '#f0f0f1',
	cream: '#f2eeb1',
	grey: '#7a7a7a',
	graphite: '#576363',
	charcoal: '#464b58',
	black: '#000000',
	carbon: '#000000',
	peach: '#ffe5b4',
	yellow: '#ffdb00',
	orange: '#e66124',
	red: '#cb1e22',
	lavender: '#d1b6cc',
	pink: '#ffa0da',
	purple: '#76319b',
	brown: '#53362a',
	mint: '#a6c2bb',
	green: '#2e9b51',
	blue: '#3366cc',
	cyan: '#07e0e0',
	navy: '#00264b',
	steel: '#bbbbbb',
	aluminium: '#bbbbbb',
	chrome: '#bbbbbb',
	titanium: '#bbbbbb',
	silver: '#bbbbbb',
	gold: '#d4af37',
	copper: '#e6a784',
	brass: '#f6a067',
	coffee: '#835a2e',
	fawn: '#9a8778',
};

const matchColour = (colour) => {
	if (!colour) return null;

	const normalised = colour.toLowerCase().replace(/_/g, ' ');

	for (const [key, hex] of Object.entries(trueColourMap)) {
		if (normalised.includes(key)) {
			return hex;
		}
	}

	return null;
};

export const getTrueColourHex = (trueColour, colour) => {
	return matchColour(trueColour) || matchColour(colour) || '#cccccc';
};

export const isWhite = (trueColour, colour) => {
	const normaliseTrueColour = (trueColour || '').toLowerCase().replace(/_/g, ' ');
	const normaliseColour = (colour || '').toLowerCase().replace(/_/g, ' ');
	return normaliseTrueColour.includes('white') || normaliseColour.includes('white');
};

export default trueColourMap;
